import type { FC } from 'react';

import { Spinner } from '@nodal/uikit/components/Spinner';
import { Steps } from '@nodal/uikit/components/Steps';
import { Route, Routes } from 'react-router-dom';

import {
  requestPaths,
  externalPayerPaths as paths,
  externalPayerAppPaths as appPaths,
} from '@b2b/consts/paths';

import { PaymentContract } from './PaymentContract';
import { PaymentFlow } from './PaymentFlow';

import type { PaymentRequestProps } from './PaymentRequest.interface';

export const PaymentRequest: FC<PaymentRequestProps> = ({
  steps,
  activeStepIndex,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-col gap-8 py-6 mx-4 max-w-full bg-transparent sm:gap-6 sm:mx-6 lg:mx-8 2xl:mx-auto 2xl:max-w-7xl">
        <div className="flex flex-col gap-4 sm:flex sm:flex-row sm:gap-8">
          <div className="w-full h-full sm:w-72">
            <Steps steps={steps} activeIndex={activeStepIndex} />
          </div>
          <div className="flex-1 w-full">
            <Routes>
              <Route
                path={requestPaths.contract}
                element={<PaymentContract />}
              />
              <Route
                path={requestPaths.payment}
                element={
                  <PaymentFlow
                    completePath={`${paths.app}/${appPaths.paymentComplete}`}
                  />
                }
              />

              <Route
                path="*"
                element={
                  <div className="flex justify-center items-center w-full">
                    <Spinner size="large" variant="secondary" />
                  </div>
                }
              />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
